"use client"
/* */
const message = "flow--message";
const content = "flow--message--content";
const sender = "flow--message--sender";
const header = "flow--message--header";
const user = "flow--message--user";
const responder = "flow--message--responder";
const date = "flow--message--date";
const action = "flow--message--action";
const styles = {
	message: message,
	content: content,
	sender: sender,
	header: header,
	user: user,
	responder: responder,
	date: date,
	action: action
};

export { action, content, date, styles as default, header, message, responder, sender, user };
//# sourceMappingURL=Message.module.scss.mjs.map
